"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgYoutube = function SvgYoutube(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24.165 15.27c1.186.004 2.63.023 4.054.069 2.235.07 3.83.187 4.653.389a3.78 3.78 0 012.638 2.72l.014.065A29.97 29.97 0 0136 24.016a30.004 30.004 0 01-.476 5.431l-.014.066a3.786 3.786 0 01-2.652 2.723c-.759.203-2.242.328-4.327.407l-.501.018c-.845.028-1.73.047-2.613.058l-.432.005-.803.006-1.167-.006-.962-.012c-.883-.015-1.757-.037-2.584-.069-2.085-.08-3.568-.204-4.333-.408a3.78 3.78 0 01-2.638-2.611l-.022-.096A29.964 29.964 0 0112 24.025c-.01-1.835.15-3.667.476-5.472l.014-.066a3.786 3.786 0 012.652-2.723c.741-.198 2.177-.322 4.182-.402l.81-.029c1.07-.033 2.138-.052 3.087-.06l.614-.003zm-.003 2h-.32c-1.168.004-2.595.025-3.994.074l-.205.007c-1.964.073-3.414.193-3.97.341a1.78 1.78 0 00-1.243 1.28l.005-.02-.07.416a27.997 27.997 0 00-.347 3.485l-.016.704-.002.47a28 28 0 00.444 5.146l-.01-.056.02.063c.182.515.589.918 1.1 1.092l.104.032c.557.149 1.97.268 3.887.341l.492.017c.83.028 1.7.046 2.572.057l1.01.01 1.144-.003 1.15-.014c.87-.014 1.73-.036 2.542-.067l.196-.008c1.817-.074 3.152-.19 3.677-.33a1.78 1.78 0 001.242-1.28l-.007.02.071-.411c.187-1.144.302-2.298.346-3.459l.018-.697.002-.466a28.002 28.002 0 00-.444-5.146l.006.039-.02-.076a1.773 1.773 0 00-1.084-1.14l-.095-.03c-.598-.145-2.133-.257-4.208-.323l-.701-.02c-.934-.025-1.86-.039-2.69-.045zm-3.412 3.48a1 1 0 011.494-.87l5.75 3.27a1 1 0 010 1.74l-5.75 3.27a1 1 0 01-1.494-.87zm2 1.719v3.102l2.727-1.551z",
    id: "youtube_svg__path-1"
  }));
};

var _default = SvgYoutube;
exports["default"] = _default;